import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import { Grid } from "@mui/material";
import Link from "next/link";
import { H5, Paragraph } from "src/lib/components/salify-next-layout/default/components/Typography";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import useCart from "src/lib/components/salify-next-layout/default/hooks/useCart";
import CartItem from "./cart-item";
import CartArticleRightCheckout from "./cart-article-right-checkout";

const CardSectionStepCart = (props: React.PropsWithChildren<{ nextUrl: string }>) => {
  const { state } = useCart();

  if (state.cart.length === 0) {
    return (
      <Grid container justifyContent="center">
        <Grid item xs={12} md={8} lg={6}>
          <Card sx={{ p: { xs: 3, sm: 5 }, textAlign: "center" }}>
            <H5 mb={2} mt={0}>
              <SalifyFallback.Label
                path="Your cart is empty"
                default="Giỏ hàng của bạn đang trống"
              />
            </H5>
            <Paragraph color="grey.600" mb={3}>
              <SalifyFallback.Label
                path="Add products to your cart to continue shopping."
                default="Chưa có sản phẩm nào trong giỏ hàng. Hãy thêm sản phẩm để tiếp tục mua sắm."
              />
            </Paragraph>
            <Button component={Link} href="/" variant="contained" color="primary" size="large">
              <SalifyFallback.Label path="Continue shopping" default="Tiếp tục mua sắm" />
            </Button>
          </Card>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item md={8} xs={12}>
        {state.cart.map(({ product }, index) => (
          <CartItem key={product.id} product={product} />
        ))}
      </Grid>

      <Grid item md={4} xs={12}>
        <CartArticleRightCheckout nextUrl={props.nextUrl} />
      </Grid>
    </Grid>
  );
};

export default CardSectionStepCart;
